import React, {useState, useEffect,useContext} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { ArticleFilterSearch2} from "@gull";
import axios from 'axios'
import swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { articleHardData } from 'app/articleHardData';
import { IsAuthContext } from 'app/App';

const useLoadInit = () => {
    const t = useTranslate();
    const [sendData, setSendData] = useState({})
    const [filtre,setFiltre] = useState({})
    const [kpiFilterList,setKpiFilterList] = useState({})

    useEffect(function () {
        (async function() {
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/pos/kpi_filter/get_all"
                ).then((response) => {
                    setKpiFilterList(response.data.datas)
                }).catch((error) => {
                    if(error=='end_session') return;
                    let messageError
                    if(error.response==undefined){
                        messageError='unknowError'
                    }
                    else if(error.response.status==403){
                        messageError='forbiddenGeneral'
                    }
                    else {
                        messageError='unknowError'
                    }
                    
                    swal.fire(t(messageError), "", "error");
                })
        })()
    }, [])
    
    return [sendData,setSendData,filtre,setFiltre]
}

const AddFilter = (props) => {
    const t = useTranslate();
    const [sendData,setSendData,filtre,setFiltre] = useLoadInit()
    const [showModalCustomFiltre, setShowModalCustomFiltre] = useState(false);
    const [disabledAddSelection,setDisabledAddSelection]=useState(true) 
    const [validButton,setValidButton]=useState(false) 
    const { authParam } = useContext(IsAuthContext);
    const moduleErp = authParam.modules.find(value=>value.name=='erp')

    useEffect(function () {
        const isAnyKeyNonEmptyArray = Object.values(sendData).some(value => Array.isArray(value) && value.length > 0);

        if(isAnyKeyNonEmptyArray){
            setDisabledAddSelection(false)
        }else{
            setDisabledAddSelection(true) 
        }
    }, [sendData])

    const handleSelect = (e,nameInput) => {
        setSendData({...sendData,[nameInput]:e.target.value})
    }

    const handleSubmitKpiFilter = async (setFavoriteFilterActived=false) => {
        setValidButton(prev => true)
        let isEdit = props.urlAddItems.includes('edit')

        let obj
        if (isEdit) {
            obj={
                value:{...sendData},
                exclude_article:props.excludeArticle
            }
        }
        else {
            obj={
                kpi_filter_name:props.kpiFilterName,
                value:{...sendData},
                exclude_article:props.excludeArticle
            }
        }
        
        const response = await axios.post(process.env.REACT_APP_API_URL+props.urlAddItems,obj
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach((interm)=>{
                    let finalMessage=interm.split('/!');
                    if(finalMessage.length==2){
                        messageError+=t(finalMessage[0],{name:finalMessage[1]})+','
                    }
                    else{
                        messageError+=t(interm)+','
                    }
                })
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else {
                if (setFavoriteFilterActived!=false) setFavoriteFilterActived(false)
                setFiltre('')
                if (props.setKpiFilterName) props.setKpiFilterName('')
                if (props.setExcludeArticle) props.setExcludeArticle(false)
                if (isEdit) props.setKpiFilter(response.data.data)
                props.setRelance(Date.now())
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setValidButton(prev => false)
    }

    const handleKpiFilterReset = (setFavoriteFilterActived=false) => {
        if (setFavoriteFilterActived!=false) setFavoriteFilterActived(false) 
        setFiltre('')
        if (props.setKpiFilterName) props.setKpiFilterName('')
        if (props.setExcludeArticle) props.setExcludeArticle(false)
        props.setRelance(Date.now())
    }

    return (
        <>
            {props.children}
            <div className="row">
                <div className="col">
                    <ArticleFilterSearch2
                        liaisons={props.liaisons}
                        customFields={props.customFields}
                        setReload={props.setReload}
                        setFiltre={setFiltre}
                        customInterface={props.customInterface}
                        setCustomInterface={props.setCustomInterface}
                        sendData={sendData}
                        setSendData={setSendData}
                        setShowModalCustomFiltre={setShowModalCustomFiltre}
                        showModalCustomFiltre={showModalCustomFiltre}
                        initAllFilter={{}}
                        interface='filtreArticle' //Variable qui permet d'identifier l'url sur laquelle filtrer
                        hardData={articleHardData}
                        moduleName='items'

                        tableName={props.tableName}
                        setToast={props.setToast}

                        kpiFilterBtn={true}
                        kpiFilterName={props.kpiFilterName}
                        from={props.from}
                        disabledAddSelection={disabledAddSelection}
                        loading={validButton}
                        handleSubmitKpiFilter={handleSubmitKpiFilter}
                        handleKpiFilterReset={handleKpiFilterReset}
                        kpiFilter={props.kpiFilter}
                    >
                        <div className="row d-flex justify-content-between">
                            {(moduleErp.params.stock.active) &&
                                <div className="col-3">
                                    <div className="form-group">
                                        <label className="col-form-label col-form-label-sm">{t('itemHaveStock')}</label>
                                        <select className="form-control form-control-sm" value={sendData.havestock} onChange={(e) => handleSelect(e,'havestock')}>
                                            <option value="">{t('itemLinkAndNotLinkToTock')}</option>
                                            <option value="oui">{t('itemLinkToTock')}</option>
                                            <option value="non">{t('itemNotLinkToTock')}</option>
                                        </select>
                                    </div>
                                </div>
                            }       
                            
                        </div>
                    </ArticleFilterSearch2>
                </div>
            </div>
        </>
    )
}

export default AddFilter;
